<template>
  <div class="slider-container">
    <div class="d-flex-row justify-start flex-8">
      <label for="range" class="medium-l font-family-2 t-light">{{
        min
      }}</label>
      <input
        type="range"
        :min="min"
        :max="max"
        v-model="sliderValue"
        class="range-slider"
        id="range"
        ref="range-slider"
      />
      <label for="range" class="medium-l font-family-2 t-light">{{
        max
      }}</label>
    </div>
    <div class="flex-1 range-value d-flex-row">
      <input
        type="number"
        class="t-blue font-family-2 bold-xxxl"
        v-model="slider"
      />
      <!-- {{ sliderValue }} -->
      <!-- </label> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sliderValue: 1,
      slider: 1,
      timeout: null,
    };
  },
  props: {
    min: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: 10,
    },
    modelValue: {
      default: null,
    },
    defaultValue: {
      default: 1,
    },
  },
  methods: {
    changeSlider() {
      const reducer = parseInt(this.sliderValue - this.min);
      const max = this.max - this.min;
      let valPercent = (reducer / max) * 100;

      const el = this.$refs["range-slider"];
      el.style.background = `linear-gradient(to right, #48E4FF ${valPercent}%, #45494D ${valPercent}%)`;
    },
  },

  watch: {
    sliderValue() {
      if (this.slider !== this.sliderValue) {
        this.slider = this.sliderValue;
      }
      this.changeSlider();
      if (this.modelValue !== null) {
        this.$emit("update:modelValue", this.sliderValue);
      }
      if (!this.sliderValue) {
        this.sliderValue = this.min;
      }
      if (this.sliderValue > this.max) {
        this.sliderValue = this.max;
      }
    },
    min() {
      this.changeSlider();
    },
    max() {
      this.changeSlider();
    },
    modelValue() {
      const val = parseInt(this.modelValue);
      if (val !== this.sliderValue) {
        this.sliderValue = val;
      }
    },
    slider() {
      if (this.slider === this.sliderValue) {
        return;
      }
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      let value = parseInt(this.slider);
      if (this.slider > this.max) {
        value = this.max;
      }
      if (this.slider < this.min) {
        value = this.min;
      }

      this.timeout = setTimeout(() => {
        this.sliderValue = value;
        this.slider = value;
      }, 500);
    },
  },
  mounted() {
    if (this.defaultValue > this.sliderValue) {
      this.sliderValue = this.defaultValue;
    }
    this.changeSlider();
  },
};
</script>
